export default __webpack_public_path__ + "static/media/belu.6473246d.png";